<template>
  <div>
    <v-card>
      <v-row>
        <v-col>
          <v-card-title>Employee Contribution Export</v-card-title>
        </v-col>
   
        <v-col
          cols="2"
          class="ma-auto"
        >
          <v-btn
            class="mx-3"
            color="primary"
            :loading="loading"
            @click="generate"
          >
            generate
          </v-btn>
        </v-col>
      </v-row>
    </v-card> 
  </div>
</template>

<script>
  export default {
    data () {
      return {
        loading: false,
      }
    },
    methods: {
      generate () {
        this.loading = true

        this.$api.payrollExports().employeeContributionExport()
          .then((res) => {
            let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.setAttribute('download', 'Employee Contribution.xlsx') 
            link.click()
            this.loading = false

            this.$snack({ message: 'Employee contribution downloaded successfully' })
          }).catch(e => {
            this.loading = false
            if (e.response.status === 400) {
              this.$snack({ 
                color: 'error',
                message: e.response.data.status, 
              })
            }
          })
      },
    },
  }
</script>
